export enum EPollType {
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
}
